import { inject, Injectable } from '@angular/core';
import { Action, NgxsOnInit, State, StateContext, Store } from '@ngxs/store';
import { SocketIoService } from './socket-io.service';
import { catchError, interval, of } from 'rxjs';
import {
  SocketIoJoinChat,
  SocketIoLeaveChat,
  SocketIoSetupEventListeners,
} from './socket-io.action';
import {
  assertUnreachable,
  NotificationMessagingDataPayload,
  NotificationMessagingType,
} from '@aimi/models';
import { FmErrorHandlerService } from '../../core/fm-error-handler.service';
import { SocketIoMessageHandlerService } from './socket-io-message-handler.service';

interface SocketMessage {
  sender: string;
  text: {
    room: string;
    text: string;
  };
}

@State<unknown>({
  name: 'SocketIoState',
  defaults: {},
})
@Injectable()
export class SocketIoState implements NgxsOnInit {
  #socketIoService = inject(SocketIoService);
  #socketIoMessageHandlerService = inject(SocketIoMessageHandlerService);

  ngxsOnInit(ctx: StateContext<any>): void {
    ctx.dispatch(new SocketIoSetupEventListeners());
  }

  @Action(SocketIoSetupEventListeners)
  setupEventListeners() {
    this.#socketIoService
      .listen<SocketMessage>('sendMessage')
      .subscribe((message) => {
        console.log('message', message);
        if (!message) {
          return;
        }
        const payload = JSON.parse(message.text.text);
        this.#handleSocketIoMessage(payload);
      });
  }

  @Action(SocketIoJoinChat)
  joinChat(ctx: StateContext<unknown>, action: SocketIoJoinChat) {
    return this.#socketIoService.joinRoom(action.chatId);
  }

  @Action(SocketIoLeaveChat)
  leaveChat(ctx: StateContext<unknown>, action: SocketIoLeaveChat) {
    return this.#socketIoService.leaveRoom(action.chatId);
  }

  async #handleSocketIoMessage(
    payload: NotificationMessagingDataPayload | undefined,
  ) {
    console.log('payload', payload);
    if (!payload) {
      console.warn('empty data payload');
      return;
    }
    switch (payload.type) {
      case NotificationMessagingType.GEMINI_RESPONSE:
        this.#socketIoMessageHandlerService.handleGeminiResponse(payload);
        break;
      case NotificationMessagingType.GEMINI_RESPONSE_UPDATE:
        this.#socketIoMessageHandlerService.handleGeminiResponseUpdate(payload);
        break;
      default:
        assertUnreachable(payload.type, 'unhandled notification type.');
        break;
    }
  }
}
